<template>
  <div>
    <p class="d-flex flex-column align-items-center">
      <img
        src="/assets/images/stripe.png"
        width="200"
        alt="Payment Providers"
      >
      <br>
      <span style="opacity: 0.7;">
        All payments processed through
        <a
          href="https://stripe.com/gb"
          target="_blank"
        >Stripe</a>.
      </span>
    </p>
  </div>
</template>
